// Suitability: peer review: the routes and the sidebar rows of `wealth.onboarding.suitability.peer-review` (ADR-0027).
import { lazy } from 'react';
import { defineWebFeature } from '@/features/kit';

const PeerReviewsCard = lazy(() =>
    import('./suitability-peer-review.slots').then((m) => ({ default: m.PeerReviewsCard })),
);

export default defineWebFeature({
    id: 'wealth.onboarding.suitability.peer-review',
    routes: [
        {
            frontend: 'desk',
            path: 'peer-reviews',
            lazy: () => import('@/pages/desk/peer-reviews/page'),
        },
        {
            frontend: 'desk',
            path: 'peer-reviews/:assignmentId',
            lazy: () => import('@/pages/desk/peer-reviews/assignment/page'),
        },
    ],
    nav: [
        // SEP-243 sections 31, 32 and 41 - the peer review work queue. Compliance
        // assigns each case, and the row lists the assignments of the signed-in
        // investment manager alone. Barred for im-assistant: a peer review is the
        // judgement of an investment manager (persona-model.ts).
        {
            frontend: 'desk',
            key: 'peer-reviews',
            label: 'Peer Reviews to Complete',
            href: '/desk/peer-reviews',
            icon: 'UserCheck',
            group: 'advice-suitability',
            order: 440,
        },
    ],
    slots: {
        // SEP-329. The peer reviews that wait for the IM, on the Desk Dashboard.
        // An assistant has no peer review, so the card is for the Desk lens only.
        'desk.dashboard.cards': [
            {
                key: 'peer-reviews',
                order: 60,
                span: 6,
                // The height of the risk profile card beside it.
                rows: 4,
                personas: ['desk'],
                title: 'Peer reviews to complete',
                summary: 'The peer reviews that Compliance assigned to you.',
                // The card reads the queue with its own hook, so the page
                // cannot know the count. The card has no count, and it never
                // collapses.
                Component: PeerReviewsCard,
            },
        ],
    },
});
